import React, { useMemo } from 'react';
import { useAdp } from '../integrations/useAdp';
import { useSandbox } from '../integrations/useSandbox';
import { usePaycom } from '../integrations/usePaycom';
import { useOnlyFans } from '../integrations/useOnlyFans';
import { useWorkday } from '../integrations/useWorkday';
import { useWorkdayAlt } from '../integrations/useWorkdayAlt';
import { useHrblock } from '../integrations/useHrblock';
import { useAmazon } from '../integrations/useAmazon';
import { usePaylocity } from '../integrations/usePaylocity';
import { usePaycor } from '../integrations/usePaycor';
import { useJustworks } from '../integrations/useJustworks';
import { useWalmart } from '../integrations/useWalmart';
import { usePaychex } from '../integrations/usePaychex';
import { useUltipro } from '../integrations/useUltipro';
import { useUltiproOkta } from '../integrations/useUltiproOkta';
import { useGusto } from '../integrations/useGusto';
import { useKroger } from '../integrations/useKroger';
import { useCeridian } from '../integrations/useCeridian';
import { useSocialSecurity } from '../integrations/useSocialSecurity';
import { useTaxAct } from '../integrations/useTaxAct';
import { useTaxSlayer } from '../integrations/useTaxSlayer';
import useCheckLoadedAndShowSPA from './useCheckLoadedAndShowSPA';
import { useIrs } from '../integrations/useIrs';
import { useLibertyTax } from '../integrations/useLibertyTax';
import { useJacksonHewitt } from '../integrations/useJacksonHewitt';
import { useRippling } from '../integrations/useRippling';
import { usePublix } from '../integrations/usePublix';
import { useVaBenefits } from '../integrations/useVaBenefits';
import { usePersonaTest } from '../integrations/usePersonaTest';
import { useDoorDash } from '../integrations/useDoorDash';
import { useDailyPay } from '../integrations/useDailyPay';
import { useToast } from '../integrations/useToast';
import { useKaiserPermanente } from '../integrations/useKaiserPermanente';
export default function useIntegration(successCriteria) {
    var Component = useMemo(function () {
        if (successCriteria === 'auth=adp')
            return function IntegrationComponent() {
                useAdp();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=paycom')
            return function IntegrationComponent() {
                usePaycom();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=onlyFans')
            return function IntegrationComponent() {
                useOnlyFans();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=workday')
            return function IntegrationComponent() {
                useWorkday();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=workday-alt')
            return function IntegrationComponent() {
                useWorkdayAlt();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=persona-test')
            return function IntegrationComponent() {
                usePersonaTest();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=hrblock')
            return function IntegrationComponent() {
                useHrblock();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=amazon')
            return function IntegrationComponent() {
                useAmazon();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=paylocity')
            return function IntegrationComponent() {
                usePaylocity();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=paycor')
            return function IntegrationComponent() {
                usePaycor();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=walmart')
            return function IntegrationComponent() {
                useWalmart();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=justworks')
            return function IntegrationComponent() {
                useJustworks();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=paychex')
            return function IntegrationComponent() {
                usePaychex();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=ultipro')
            return function IntegrationComponent() {
                useUltipro();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=ultipro-okta')
            return function IntegrationComponent() {
                useUltiproOkta();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=kroger')
            return function IntegrationComponent() {
                useKroger();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=gusto')
            return function IntegrationComponent() {
                useGusto();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=ceridian')
            return function IntegrationComponent() {
                useCeridian();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=socialsecurity')
            return function IntegrationComponent() {
                useSocialSecurity();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=irs')
            return function IntegrationComponent() {
                useIrs();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=single_page_application_test')
            return function IntegrationComponent() {
                useCheckLoadedAndShowSPA();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=taxslayer')
            return function IntegrationComponent() {
                useTaxSlayer();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=taxact')
            return function IntegrationComponent() {
                useTaxAct();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=libertytax')
            return function IntegrationComponent() {
                useLibertyTax();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=jacksonhewitt')
            return function IntegrationComponent() {
                useJacksonHewitt();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=rippling')
            return function IntegrationComponent() {
                useRippling();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=publix')
            return function IntegrationComponent() {
                usePublix();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=vabenefits')
            return function IntegrationComponent() {
                useVaBenefits();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=doorDash')
            return function IntegrationComponent() {
                useDoorDash();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=dailyPay')
            return function IntegrationComponent() {
                useDailyPay();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=toast')
            return function IntegrationComponent() {
                useToast();
                return React.createElement(React.Fragment, null);
            };
        if (successCriteria === 'auth=kaiserPermanente')
            return function IntegrationComponent() {
                useKaiserPermanente();
                return React.createElement(React.Fragment, null);
            };
        return function IntegrationComponent() {
            useSandbox();
            return React.createElement(React.Fragment, null);
        };
    }, [successCriteria]);
    return Component;
}
